export default {

   taleSendStatus:true,
   taleConfirmStatus:false,

    //test amaçlı ekledim.

    //2.TEST
    
    copright:'Her hakkı saklıdır. Atatürk Kültür Merkezi Başkanlığı',
    coprightYear:'2019',
  
   // apiUrl:"http://192.168.55.66:3300",
   // apiUrl:"http://node2.ayk.gov.tr/api/",

    devConfig: {
      apiUrl:"http://localhost:3300",
      mainPageUrl : "http://localhost:3005/signin",
    },
    testConfig:{
      apiUrl:"https://test.masal.gov.tr/api/",
      mainPageUrl : "/",
    },
    prodConfig:{
      apiUrl:"https://www.masal.gov.tr/api/",
      mainPageUrl : "/",
    },  

    coefficientOfPayment:25.10 ,


  defaultProfileImageUrl: "/uploads/images/user.jpg",

    titleList : [
       
        "Prof.Dr.",
        "Doç.Dr.",
        "Dr. Öğr. Üyesi",
        "Öğr. Gör.",
        "Arş. Gör.",
        "Arş. Gör. Dr.",
        "Dr.",
        "Öğretmen",
        "Uz.",
      
    ],
    mounth:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],
    citys : ['','Adana', 'Adıyaman', 'Afyon', 'Ağrı', 'Amasya', 'Ankara', 'Antalya', 'Artvin',
    'Aydın', 'Balıkesir', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale',
    'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır', 'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir',
    'Gaziantep', 'Giresun', 'Gümüşhane', 'Hakkari', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir', 
    'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya', 
    'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu', 'Rize', 'Sakarya',
    'Samsun', 'Siirt', 'Sinop', 'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak',
    'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale', 'Batman', 'Şırnak',
    'Bartın', 'Ardahan', 'Iğdır', 'Yalova', 'Karabük', 'Kilis', 'Osmaniye', 'Düzce', 'Bölgesi Bilinmiyor'],
    areas: [
        {
          id:0,
          value: "",
          label: ""
          ,color :"success"
        },
        {
          id:1,
          value: "Doğu Anadolu Bölgesi",
          label: "Doğu Anadolu Bölgesi"
          ,color :"warning"
        },
        {
          id:2,
          value: "İç Anadolu Bölgesi",
          label: "İç Anadolu Bölgesi"
          ,color :"primary"
        },
        {
          id:3,
          value: "Marmara Bölgesi",
          label: "Marmara Bölgesi"
          ,color :"success"
        },
        {
          id:4,
          value: "Güneydoğu Anadolu Bölgesi",
          label: "Güneydoğu Anadolu Bölgesi"
          ,color :"info"
        },
        {
          id:5,
          value: "Akdeniz Bölgesi",
          label: "Akdeniz Bölgesi"
          ,color :"danger"
        },
        {
          id:6,
          value: "Karadeniz Bölgesi",
          label: "Karadeniz Bölgesi"
          ,color :"secondary"
        },
        {
          id:7,
          value: "Ege Bölgesi",
          label: "Ege Bölgesi"
          ,color :"teal"
        },
        {
          id:8,
          value: "Bölgesi Bilinmiyor",
          label: "Bölgesi Bilinmiyor"
          ,color :"danger"
        }
      ],
   
   
     citys2 : [{value:"Balıkesir", areaId:3},
     {value:"Bilecik", areaId:3},
     {value:"Bursa", areaId:3},
     {value:"Çanakkale", areaId:3},
     {value:"Edirne", areaId:3},
     {value:"İstanbul", areaId:3},
     {value:"Kırklareli", areaId:3},
     {value:"Kocaeli", areaId:3},
     {value:"Sakarya ", areaId:3},
     {value:"Tekirdağ", areaId:3},
     {value:"Yalova", areaId:3},
     {value:"Afyonkarahisar", areaId:7},
     {value:"Aydın", areaId:7},
     {value:"Denizli", areaId:7},
     {value:"İzmir", areaId:7},
     {value:"Kütahya", areaId:7},
     {value:"Manisa", areaId:7},
     {value:"Muğla", areaId:7},
     {value:"Uşak", areaId:7},
     {value:"Adana", areaId:5},
     {value:"Antalya", areaId:5},
     {value:"Burdur", areaId:5},
     {value:"Hatay ", areaId:5},
     {value:"Isparta", areaId:5},
     {value:"Mersin", areaId:5},
     {value:"Kahramanmaraş", areaId:5},
     {value:"Osmanıye", areaId:5},
     {value:"Aksaray", areaId:2},
     {value:"Ankara", areaId:2},
     {value:"Çankırı", areaId:2},
     {value:"Eskişehir", areaId:2},
     {value:"Karaman", areaId:2},
     {value:"Kayseri", areaId:2},
     {value:"Kırıkkale", areaId:2},
     {value:"Kırşehir", areaId:2},
     {value:"Konya", areaId:2},
     {value:"Nevşehir", areaId:2},
     {value:"Niğde", areaId:2},
     {value:"Sivas", areaId:2},
     {value:"Yozgat", areaId:2},
     {value:"Adıyaman", areaId:4},
     {value:"Batman", areaId:4},
     {value:"Diyarbakır", areaId:4},
     {value:"Gaziantep", areaId:4},
     {value:"Kilis", areaId:4},
     {value:"Mardin", areaId:4},
     {value:"Siirt", areaId:4},
     {value:"Şırnak", areaId:4},
     {value:"Şanlıurfa", areaId:4},
     {value:"Ağrı", areaId:1},
     {value:"Ardahan", areaId:1},
     {value:"Bingöl", areaId:1},
     {value:"Bitlis", areaId:1},
     {value:"Elazığ", areaId:1},
     {value:"Erzincan", areaId:1},
     {value:"Erzurum", areaId:1},
     {value:"Hakkari", areaId:1},
     {value:"Iğdır", areaId:1},
     {value:"Kars", areaId:1},
     {value:"Malatya", areaId:1},
     {value:"Muş", areaId:1},
     {value:"Tunceli", areaId:1},
     {value:"Van", areaId:1},
     {value:"Amasya", areaId:6},
     {value:"Artvin", areaId:6},
     {value:"Bartın", areaId:6},
     {value:"Bayburt", areaId:6},
     {value:"Bolu", areaId:6},
     {value:"Çorum", areaId:6},
     {value:"Düzce", areaId:6},
     {value:"Giresun", areaId:6},
     {value:"Gümüşhane", areaId:6},
     {value:"Karabük", areaId:6},
     {value:"Kastamonu", areaId:6},
     {value:"Ordu", areaId:6},
     {value:"Rize", areaId:6},
     {value:"Samsun", areaId:6},
     {value:"Sinop", areaId:6},
     {value:"Tokat", areaId:6},
     {value:"Trabzon", areaId:6},
     {value:"Zonguldak", areaId:6},
     {value:"Bilinmiyor", areaId:8}
     
     ],
      educationLevels : [ "","Bilinmiyor", "Okur-Yazar Değil", "Okur-Yazar","İlkokul","Ortaokul","Lise","Lisans","YüksekLisans","Doktora"],

      fileAcceptExtension : [
         'video/x-flv'
        ,'video/mp4'
        ,'application/x-mpegURL'
        ,'video/MP2T'
        ,'video/3gpp'
        ,'video/quicktime'
        ,'video/x-msvideo'
        ,'video/x-ms-wmv'
        ,'audio/basic'
        ,'audio/mid'	
        ,'audio/mpeg	RFC 3003'
        ,'audio/mpeg'
        ,'audio/mp3'
        ,'audio	audio/mp4'	
        ,'audio/x-mpegurl'
        ,'Vorbis	audio/ogg	RFC 5334'
        ,'audio/vnd.wav'
        ,'image/cgm'
        ,'image/fits'
        ,'image/g3fax'
        ,'image/gif'
        ,'image/ief'
        ,'image/jp2'
        ,'image/jpeg'
        ,'image/jpm'
        ,'image/jpx'
        ,'image/naplps'
        ,'image/png'
        ,'image/prs.btif'
        ,'image/prs.pti'
        ,'image/t38'
        ,'image/tiff'
        ,'image/tiff-fx'
        ,'image/vnd.adobe.photoshop'
        ,'image/vnd.cns.inf2'
        ,'image/vnd.djvu'
        ,'image/vnd.dwg'
        ,'image/vnd.dxf'
        ,'image/vnd.fastbidsheet'
        ,'image/vnd.fpx'
        ,'image/vnd.fst'
        ,'image/vnd.fujixerox.edmics-mmr'
        ,'image/vnd.fujixerox.edmics-rlc'
        ,'image/vnd.globalgraphics.pgb'
        ,'image/vnd.microsoft.icon'
        ,'image/vnd.mix'
        ,'image/vnd.ms-modi'
        ,'image/vnd.net-fpx'
        ,'image/vnd.sealed.png'
        ,'image/vnd.sealedmedia.softseal.gif'
        ,'image/vnd.sealedmedia.softseal.jpg'
        ,'image/vnd.svf'
        ,'image/vnd.wap.wbmp'
        ,'image/vnd.xiff'
        ,'application/msword'
        ,'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ,'application/vnd.ms-powerpoint'
        ,'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ,'application/pdf'
      ]
}